import { CheckIcon } from '@chakra-ui/icons';
import { Box, Flex, useClipboard, useToast } from '@chakra-ui/react';
import IconContainer from '@components/pages/articles/Article/templates/IconContainer';
import checkmark from '@public/assets/icons/checkmark.svg';
import { FsmColors } from 'chakra-ui/fsmTheme';
import Image from 'next/image';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share';
import Body2 from '../typography/Body2';
import Button, { ButtonVariants } from './Button';

const ShareButtons = ({ href, size = 32 }) => {
  // Facebook will not work locally because it denies localhost
  const { hasCopied, onCopy, value } = useClipboard(href);
  const toast = useToast();
  const toastId = 'link';

  return (
    <Box display="flex" flexWrap="nowrap" gap={2}>
      <Button
        width="109px"
        id="copy-share"
        size="sm"
        padding="0px"
        fontSize={16}
        borderRadius="200px"
        variant={ButtonVariants.primary}
        onClick={() => {
          onCopy();
          if (!toast.isActive(toastId)) {
            toast({
              duration: 2000,
              position: 'bottom',
              id: toastId,
              render: () => (
                <Flex
                  bg="highlight"
                  py={4}
                  px={8}
                  mb={12}
                  borderRadius={99}
                  alignItems="center"
                  gap={3}
                  width="fit-content"
                  mx="auto"
                >
                  <Image src={checkmark} alt="Checkmark" />
                  <Body2 bold>Link Copied.</Body2>
                </Flex>
              ),
            });
          }
        }}
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={1}
      >
        {hasCopied ? <CheckIcon width="18px" bg="transparent" /> : <>Copy Link</>}
      </Button>
      <IconContainer size={size}>
        <EmailShareButton url={value} id="email-share">
          <EmailIcon size={size} bgStyle={{ fill: FsmColors.red }} round />
        </EmailShareButton>
      </IconContainer>
      <IconContainer size={size}>
        <TwitterShareButton url={value} id="twitter-share">
          <TwitterIcon size={size} round />
        </TwitterShareButton>
      </IconContainer>
      <IconContainer size={size}>
        <FacebookShareButton url={value} id="facebook-share">
          <FacebookIcon size={size} round />
        </FacebookShareButton>
      </IconContainer>
    </Box>
  );
};

export default ShareButtons;
